import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const DayRow = styled.div`
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 0;
    border-top: 1px solid ${colors.borderSofter};
`;

export const DayToggle = styled.div`
    flex: 1 1 200px;
    min-width: 0;
`;

export const DayTimes = styled.div`
    display: flex;
    gap: 12px;
    flex: 0 1 260px;

    & > * {
        flex: 1 1 0;
        min-width: 0;
    }
`;
